/** 文件说明
@Author: dalang
@LastModifyTime: 2022-05-08  17:41:46
@Desc: 个人中心-万知商务模块路由表(商家)
**/

export default {
  path: '/seller/wzmall',
  name: 'SellerMall',
  component: () => import('@/components/user/business'),
  meta: {
    title: '万知商务-商户中心'
  },
  children: [
    {
      path: '/seller/wzmall/first',
      name: 'Order',
      component: () => import('@/components/user/businessSeller'),
      meta: {
        title: '商户中心-主应用'
      },
      children: [{
        path: '/seller/wzmall/sellerBrand',
        name: 'SellerBrand',
        component: () => import('@/components/user/businessSeller/sellerBrand'),
        meta: {
          title: '商户中心-商家品牌'
        }
      }, {
        path: '/seller/wzmall/sellerRuZhu',
        name: 'SellerBrand',
        component: () => import('@/components/user/businessSeller/sellerRuZhu'),
        meta: {
          title: '商户中心-店铺入驻信息'
        }
      }, {
        path: '/seller/wzmall/goodList',
        name: 'GoodList',
        component: () => import('@/components/user/businessSeller/goodList'),
        meta: {
          title: '商户中心-商品列表'
        }
      }, {
        path: '/seller/wzmall/userComment',
        name: 'UserComment',
        component: () => import('@/components/user/businessSeller/userComment'),
        meta: {
          title: '商户中心-用户评论'
        }
      }, {
        path: '/seller/wzmall/userMessage',
        name: 'UserMessage',
        component: () => import('@/components/user/businessSeller/userMessage'),
        meta: {
          title: '商户中心-用户留言'
        }
      }, {
        path: '/seller/wzmall/goodClassify',
        name: 'GoodClassify',
        component: () => import('@/components/user/businessSeller/goodClassify'),
        meta: {
          title: '商户中心-商品分类'
        }
      }, {
        path: '/seller/wzmall/distributMode',
        name: 'DistributMode',
        component: () => import('@/components/user/businessSeller/distributMode'),
        meta: {
          title: '商户中心-配送方式/自提点'
        }
      }, {
        path: '/seller/wzmall/orderList',
        name: 'OrderList',
        component: () => import('@/components/user/businessSeller/orderList'),
        meta: {
          title: '商户中心-订单列表'
        }
      }, {
        path: '/seller/wzmall/storeSettle',
        name: 'StoreSettle',
        component: () => import('@/components/user/businessSeller/storeSettle'),
        meta: {
          title: '商户中心-店铺结算'
        }
      }, {
        path: '/seller/wzmall/returnApplicatList',
        name: 'ReturnApplicatList',
        component: () => import('@/components/user/businessSeller/returnApplicatList'),
        meta: {
          title: '商户中心-退货申请列表'
        }
      }, {
        path: '/seller/wzmall/goodList/recycliStation',
        name: 'RecyclingStation',
        component: () => import('@/components/user/businessSeller/goodList/RecyclingStation'),
        meta: {
          title: '商户中心-商品回收站'
        }
      },
      // {
      //   path: '/seller/wzmall/queryWuliuinfo',
      //   name: 'QueryWuliuinfo',
      //   component: () => import('@/components/user/businessSeller/wuliu'),
      //   meta: {
      //     title: '商户中心-快递查询'
      //   }
      // },
      {
        path: '/seller/wzmall/publishGoods',
        name: 'PublishGoods',
        component: () => import('@/components/user/businessSeller/goodList/PublishGood'),
        meta: {
          title: '商户中心-发布商品'
        }
      },
      {
        path: '/seller/wzmall/editPublishGoods',
        name: 'EditPublishGoods',
        component: () => import('@/components/user/businessSeller/goodList/editPublishhGoods/PublishGood'),
        meta: {
          title: '商户中心-编辑商品'
        }
      }, {
        path: '/seller/wzmall/bindGoodAttr',
        name: 'BindGoodAttr',
        component: () => import('@/components/user/businessSeller/goodList/goodAttr'),
        meta: {
          title: '商户中心-商品规格'
        }
      }, {
        path: '/seller/wzmall/products',
        name: 'Products',
        component: () => import('@/components/user/businessSeller/goodList/product'),
        meta: {
          title: '商户中心-货品列表'
        }
      }, {
        path: '/seller/wzmall/photos',
        name: 'Photos',
        component: () => import('@/components/user/businessSeller/goodList/photoAlbum'),
        meta: {
          title: '商户中心-商品照片'
        }
      }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/businessPersonCenterSeller.js